export const CREATING = 'CREATING';
export const EDITING = 'EDITING';
export const VIEWING = 'VIEWING';
export const LOAD = 'LOAD';
export const GENERATING_UNIT = 'GEN_UNIT';
export const POWER_IMPORT = 'POWER_IMPORT';
export const POWER_EXPORT = 'POWER_EXPORT';
export const CONTINUE = 'Continue';
export const BACK = 'Back';
export const ADD = 'Add Resource';
export const HOUR_FILTER = '1H';
export const HOURS_4_FILTER = '4H';
export const HOURS_24_FILTER = '24H';
export const WEEK_FILTER = '1W';
export const MONTH_FILTER = '1M';
export const MONTH_3_FILTER = '3M';
export const breadcrumbsify = (bread: string) =>
  bread.replaceAll('/', '').replaceAll('-', ' ');

// export const tranform = <T>(resource: T<IFieldsFormat<K>>) => {
//   let transformed: Record<string, any> = {};
//   Object.keys(resource).forEach((key) => {
//     resource[key as keyof FormikValues].value;
//     transformed[key] = value;
//   });
//   return transformed;
// };
